import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { updateStepData } from "../../redux/actions/actions";
import { Checkbox } from './../Checkbox';
import { ButtonContainer } from './../ButtonContainer/ButtonContainer';

const checkboxLabels = [
  "Лист А4", "Ручка или Карандаш",
  "Мягкий метр", "Два любых небольших предмета",
  "Я в носках, в которых буду ходить в обуви"
];

const STEP_NUMBER = 1;
export const GetReadySlide = ({nextStep, prevStep}) =>  {
    const stepData = useSelector(state => state.stepsData.filter(stepData => stepData.stepNumber === STEP_NUMBER)[0]);
    const dispatch = useDispatch();
    const showNextButton = true;

    return (
      <React.Fragment>
        <div className="fadeIn">
          <h1>Приготовьтесь</h1>
          {checkboxLabels.map((label, index) => (
             <Checkbox label={label}
                             key={index}
                             checked={stepData.checkBoxValues[index]}
                             index={index}
            />
          ))}
        </div>
        <ButtonContainer prevStep={prevStep} nextStep={nextStep} showNextButton={showNextButton}/>
      </React.Fragment>
    );
};


